import { useTranslation } from 'react-i18next';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { useEffect, useState } from 'react';
import { Scatter } from 'react-chartjs-2';
import scatterPalette from 'assets/js/palette';
import 'styles/global.css';

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);

interface ScatterChartProps {
  chartData: any;
}

export const ScatterChart = ({ chartData }: ScatterChartProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<any>({});

  useEffect(() => {
    const optionsData = {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    };

    setOptions(optionsData);
  }, []);

  const getData = (chartData: any) => {
    const datasets: any[] = [];

    const bgColors = scatterPalette('cb-Custom1', chartData.length).map((hex: string) => '#' + hex);

    chartData.forEach((k: any, v: number) => {
      const plots = k.plots;

      for (const plot of plots) {
        datasets.push({
          label: k.headerName,
          fill: false,
          lineTension: 0.1,
          backgroundColor: bgColors[v],
          borderColor: bgColors[v],
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: [
            {
              x: plot.xAxis,
              y: plot.yAxis,
            },
          ],
        });
      }
    });

    return {
      labels: ['Data'],
      datasets,
    };
  };

  const data = getData(chartData);

  if (data) {
    return (
      <div className="custom-chart-size-2">
        <Scatter options={options} data={data} />
      </div>
    );
  }

  return (
    <>
      <div>
        <img className="empty-state-3" src="/icons/Empty_icon.svg" alt="empty visual" />
      </div>
      <div>
        <label className="label-style-4 mt-3">{t('EMPTY_STATE.NO_DATA_FOUND')}</label>
      </div>
      <div className="w-50">
        <label className="label-style-5 mt-3">
          Please add the data to view corresponding visualisation here
        </label>
      </div>
    </>
  );
};
